import {
	META_DESCRIPTION_1,
	META_DESCRIPTION_2,
	SITE_NAME,
	TITLE_TEMPLATE,
} from "helpers/constants";

// #########################################################

const host = process.env.RAZZLE_FRONT_HOST || process.env.HOST || "localhost";
const protocol = (
	process.env.PROTOCOL ||
	process.env.RAZZLE_PROTOCOL ||
	"http"
).toLowerCase();
const isSecure = protocol === "https";
const isIp = /^\d{1,3}(\.\d{1,3}){3}$/.test(host);

const computedCookieDomain =
	process.env.COOKIE_DOMAIN ||
	process.env.RAZZLE_COOKIE_DOMAIN ||
	(!isIp && host.includes(".")
		? `.${host.split(".").slice(-2).join(".")}`
		: undefined);

const date365 = new Date();
date365.setDate(date365.getDate() + 365);

// #########################################################

export default {
	host: process.env.HOST || "localhost",
	port: process.env.PORT,
	cookieDomain: computedCookieDomain,

	auth: {
		cookieName: "auth",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
			secure: isSecure,
		},
		cookieOptionsExpress: {
			expires: date365,
			httpOnly: false,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
			secure: isSecure,
		},
	},

	language: {
		cookieName: "i18next",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
			secure: isSecure,
		},
	},
	languagePref: {
		cookieName: "datezone_language_pref",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
			secure: isSecure,
		},
	},
	fingerprint: {
		cookieName: "fpDatezone",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
			secure: isSecure,
		},
	},

	theme: {
		cookieName: "themeDatezone",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
		},
	},

	consent: {
		cookieName: "cookie_consent",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
		},
	},

	consentDetails: {
		cookieName: "cookie_consent_details",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
		},
	},

	videoSettings: {
		cookieName: "videoSettings",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
		},
	},

	viewTypes: {
		cookieName: "viewTypes",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
		},
	},

	bottomFloatingBarClosedTimestamp: {
		cookieName: "bottomFloatingBarClosedTimestamp",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
		},
	},

	installSuccessPWA: {
		cookieName: "installSuccessPWA",
		cookieOptionsJsCookie: {
			path: "/",
			expires: 365,
			sameSite: "lax",
			...(computedCookieDomain ? { domain: computedCookieDomain } : {}),
		},
	},

	app: {
		head: {
			meta: {
				title: {
					name: "title",
					content: `${SITE_NAME} - ${TITLE_TEMPLATE}`,
				},
				description: {
					name: "description",
					content: `${META_DESCRIPTION_1()} ${META_DESCRIPTION_2}`,
				},
				type: { name: "type", content: "website" },
				url: { name: "url", content: "https://www.datezone.com" },
				image: {
					name: "image",
					content:
						"https://imgcdn.datezone.com/static/img/layout/openGraph/logo_og.jpg?v=1",
				},
			},
		},
	},

	firebase: {
		config: {
			apiKey: process.env.RAZZLE_FIREBASE_CONFIG_API_KEY,
			authDomain: process.env.RAZZLE_FIREBASE_CONFIG_AUTH_DOMAIN,
			databaseURL: process.env.RAZZLE_FIREBASE_CONFIG_DATABASE_URL,
			projectId: process.env.RAZZLE_FIREBASE_CONFIG_PROJECT_ID,
			storageBucket: process.env.RAZZLE_FIREBASE_CONFIG_STORAGE_BUCKET,
			messagingSenderId:
				process.env.RAZZLE_FIREBASE_CONFIG_MESSAGING_SENDER_ID,
			appId: process.env.RAZZLE_FIREBASE_CONFIG_APP_ID,
		},
		vapidKey: process.env.RAZZLE_FIREBASE_VAPIDKEY,
		localStorage: {
			itemName: "firebaseData",
		},
	},

	MODE: {
		__DEVELOPMENT__: process?.env?.NODE_ENV === "development" ?? false,
		__PRODUCTION__: process?.env?.NODE_ENV === "production" ?? false,
	},
};

// #########################################################
